module.exports = __webpack_public_path__ + "img/shiftforcapitals.d95f2a46.png";